import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetInvoicePreviewForAppointmentPackageQueryVariables = Types.Exact<{
  getInvoicePreviewForAppointmentPackageInput: Types.GetInvoicePreviewForAppointmentPackageInput;
}>;

export type GetInvoicePreviewForAppointmentPackageQuery = {
  __typename?: "Query";
  getInvoicePreviewForAppointmentPackage: {
    __typename?: "InvoicePreview";
    total: number;
    subtotal: number;
    fees: Array<{
      __typename?: "InvoiceFee";
      code: Types.InvoiceFeeCode;
      description: string | null;
      fee: number;
      rate: number | null;
    }> | null;
    discount: {
      __typename?: "InvoiceDiscount";
      amount: number;
      rate: number;
      type: string;
    } | null;
    tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
  };
};

export type GetInvoicePreviewForAppointmentCreditsQueryVariables = Types.Exact<{
  getInvoicePreviewForAppointmentCreditsInput: Types.GetInvoicePreviewForAppointmentCreditsInput;
}>;

export type GetInvoicePreviewForAppointmentCreditsQuery = {
  __typename?: "Query";
  getInvoicePreviewForAppointmentCredits: {
    __typename?: "InvoicePreview";
    total: number;
    subtotal: number;
    fees: Array<{
      __typename?: "InvoiceFee";
      code: Types.InvoiceFeeCode;
      description: string | null;
      fee: number;
      rate: number | null;
    }> | null;
    discount: {
      __typename?: "InvoiceDiscount";
      amount: number;
      rate: number;
      type: string;
    } | null;
    tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
  };
};

export type AppointmentInvoicePreviewFragment = {
  __typename?: "InvoicePreview";
  total: number;
  subtotal: number;
  fees: Array<{
    __typename?: "InvoiceFee";
    code: Types.InvoiceFeeCode;
    description: string | null;
    fee: number;
    rate: number | null;
  }> | null;
  discount: {
    __typename?: "InvoiceDiscount";
    amount: number;
    rate: number;
    type: string;
  } | null;
  tax: { __typename?: "InvoiceTax"; amount: number; rate: number } | null;
};

export const AppointmentInvoicePreviewFragmentDoc = gql`
  fragment AppointmentInvoicePreview on InvoicePreview {
    total
    subtotal
    fees {
      code
      description
      fee
      rate
    }
    discount {
      amount
      rate
      type
    }
    tax {
      amount
      rate
    }
  }
`;
export const GetInvoicePreviewForAppointmentPackageDocument = gql`
  query GetInvoicePreviewForAppointmentPackage(
    $getInvoicePreviewForAppointmentPackageInput: GetInvoicePreviewForAppointmentPackageInput!
  ) {
    getInvoicePreviewForAppointmentPackage(
      getInvoicePreviewForAppointmentPackageInput: $getInvoicePreviewForAppointmentPackageInput
    ) {
      ...AppointmentInvoicePreview
    }
  }
  ${AppointmentInvoicePreviewFragmentDoc}
`;

/**
 * __useGetInvoicePreviewForAppointmentPackageQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewForAppointmentPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewForAppointmentPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewForAppointmentPackageQuery({
 *   variables: {
 *      getInvoicePreviewForAppointmentPackageInput: // value for 'getInvoicePreviewForAppointmentPackageInput'
 *   },
 * });
 */
export function useGetInvoicePreviewForAppointmentPackageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicePreviewForAppointmentPackageQuery,
    GetInvoicePreviewForAppointmentPackageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInvoicePreviewForAppointmentPackageQuery,
    GetInvoicePreviewForAppointmentPackageQueryVariables
  >(GetInvoicePreviewForAppointmentPackageDocument, options);
}
export function useGetInvoicePreviewForAppointmentPackageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicePreviewForAppointmentPackageQuery,
    GetInvoicePreviewForAppointmentPackageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInvoicePreviewForAppointmentPackageQuery,
    GetInvoicePreviewForAppointmentPackageQueryVariables
  >(GetInvoicePreviewForAppointmentPackageDocument, options);
}
export type GetInvoicePreviewForAppointmentPackageQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForAppointmentPackageQuery
>;
export type GetInvoicePreviewForAppointmentPackageLazyQueryHookResult =
  ReturnType<typeof useGetInvoicePreviewForAppointmentPackageLazyQuery>;
export type GetInvoicePreviewForAppointmentPackageQueryResult =
  Apollo.QueryResult<
    GetInvoicePreviewForAppointmentPackageQuery,
    GetInvoicePreviewForAppointmentPackageQueryVariables
  >;
export const GetInvoicePreviewForAppointmentCreditsDocument = gql`
  query GetInvoicePreviewForAppointmentCredits(
    $getInvoicePreviewForAppointmentCreditsInput: GetInvoicePreviewForAppointmentCreditsInput!
  ) {
    getInvoicePreviewForAppointmentCredits(
      getInvoicePreviewForAppointmentCreditsInput: $getInvoicePreviewForAppointmentCreditsInput
    ) {
      ...AppointmentInvoicePreview
    }
  }
  ${AppointmentInvoicePreviewFragmentDoc}
`;

/**
 * __useGetInvoicePreviewForAppointmentCreditsQuery__
 *
 * To run a query within a React component, call `useGetInvoicePreviewForAppointmentCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePreviewForAppointmentCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePreviewForAppointmentCreditsQuery({
 *   variables: {
 *      getInvoicePreviewForAppointmentCreditsInput: // value for 'getInvoicePreviewForAppointmentCreditsInput'
 *   },
 * });
 */
export function useGetInvoicePreviewForAppointmentCreditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInvoicePreviewForAppointmentCreditsQuery,
    GetInvoicePreviewForAppointmentCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInvoicePreviewForAppointmentCreditsQuery,
    GetInvoicePreviewForAppointmentCreditsQueryVariables
  >(GetInvoicePreviewForAppointmentCreditsDocument, options);
}
export function useGetInvoicePreviewForAppointmentCreditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvoicePreviewForAppointmentCreditsQuery,
    GetInvoicePreviewForAppointmentCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInvoicePreviewForAppointmentCreditsQuery,
    GetInvoicePreviewForAppointmentCreditsQueryVariables
  >(GetInvoicePreviewForAppointmentCreditsDocument, options);
}
export type GetInvoicePreviewForAppointmentCreditsQueryHookResult = ReturnType<
  typeof useGetInvoicePreviewForAppointmentCreditsQuery
>;
export type GetInvoicePreviewForAppointmentCreditsLazyQueryHookResult =
  ReturnType<typeof useGetInvoicePreviewForAppointmentCreditsLazyQuery>;
export type GetInvoicePreviewForAppointmentCreditsQueryResult =
  Apollo.QueryResult<
    GetInvoicePreviewForAppointmentCreditsQuery,
    GetInvoicePreviewForAppointmentCreditsQueryVariables
  >;
